import { render } from "./adminTray.vue?vue&type=template&id=7afcdcdc"
import script from "./adminTray.vue?vue&type=script&lang=js"
export * from "./adminTray.vue?vue&type=script&lang=js"

import "./adminTray.vue?vue&type=style&index=0&id=7afcdcdc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__